export default __webpack_public_path__ + "static/media/sp.5bcf78b1.png";